import { IClientGridRow } from '@/Interfaces/Client.interface';
import StatusChip from '@/components/StatusChip';
import { getActiveInactiveStatusProps } from '@/components/StatusChip/StatusProps';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

const StatusCell = ({ value }: GridRenderCellParams<IClientGridRow>) => {
  return (
    <div className='overflow-hidden'>
      <StatusChip {...getActiveInactiveStatusProps(value)} />
    </div>
  );
};

export default StatusCell;
